import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { Button } from "react-bootstrap";


const ManagementIconButton = ({ icon, onClick, color, tooltip, disabled }) => {
  return (
    <Tippy content={tooltip} interactive={true} placement="bottom">
      <Button variant={color || "outline-primary"} className={`tableBtnInside ${disabled ? "no-desc" : ""}`}
              role="button"
              onClick={onClick}>
        <i className={`fas ${icon}`} /></Button>
    </Tippy>
  );
};

export default ManagementIconButton;